import { render, staticRenderFns } from "./class_authorize.vue?vue&type=template&id=23ea518e&scoped=true"
import script from "./class_authorize.vue?vue&type=script&lang=ts"
export * from "./class_authorize.vue?vue&type=script&lang=ts"
import style0 from "./class_authorize.vue?vue&type=style&index=0&id=23ea518e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea518e",
  null
  
)

export default component.exports